import { Stack } from '@migros/msrc-ui-kit';
import React from 'react';
import { Card } from '../../elements/card/Card';
import { FixedRatioContainer } from '../../elements/fixed-ratio-container/FixedRatioContainer';
import { FrozenPictogram } from '../../elements/pictograms/FrozenPictogram';
import { ArticleBody, ArticleContainer, ArticleImage, ArticleLink, StackedBadge } from '../../elements/tiles/partials';
import { ColorVariantsIndicator } from '../../elements/variants';
import { ListStyleType, getArticleLink } from '../../helpers';
import { ConditionalImpressionObserver } from '../../helpers/ConditionalImpressionObserver';
import { ArticleSkeleton } from '../skeleton/ArticleSkeleton';
export const Article = ({
  article,
  mode,
  heading,
  hideDescription,
  hideRating,
  hideEnergyEfficiency,
  hideBadge,
  linkToFm,
  language,
  loading,
  onClick,
  onImpression,
  customTarget = {}
}) => {
  if (!loading && !!article) {
    const {
      badge_details,
      package_description,
      conditions,
      image,
      name,
      product_tile_infos,
      price_info,
      no_price_text,
      energy_efficiency,
      ratings,
      accessible_information_text
    } = article;
    const {
      additional_price_info,
      price,
      original_price
    } = price_info || {};
    const {
      price_sub_text
    } = product_tile_infos || {};
    const {
      href,
      anchorTarget
    } = getArticleLink(article, linkToFm, customTarget);
    return /*#__PURE__*/React.createElement(ConditionalImpressionObserver, {
      onImpression: onImpression
    }, /*#__PURE__*/React.createElement(Card, {
      as: "article",
      mode: mode,
      "data-testid": "msrc-articles--article"
    }, /*#__PURE__*/React.createElement(ArticleLink, {
      href: href,
      target: anchorTarget,
      onClick: onClick,
      title: name,
      "aria-label": accessible_information_text,
      "data-testid": "msrc-articles--article-link"
    }, /*#__PURE__*/React.createElement(ArticleContainer, {
      mode: mode,
      hideRating: !!hideRating,
      "aria-hidden": true
    }, image && /*#__PURE__*/React.createElement(FixedRatioContainer, {
      paddingX: mode === ListStyleType.condensed ? undefined : ['small', 'medium'],
      paddingBottom: mode === ListStyleType.condensed ? undefined : ['large', 'xlarge']
    }, /*#__PURE__*/React.createElement(ArticleImage, {
      src: image.src,
      retinaSrc: image.retina_src,
      alt: name
    })), /*#__PURE__*/React.createElement(Stack, {
      size: ['xsmall', 'small'],
      position: ['absolute'],
      bottom: ['0'],
      left: ['0'],
      right: ['0']
    }, /*#__PURE__*/React.createElement(ArticleBody, {
      name: name,
      heading: heading,
      description: price_sub_text,
      price: price ? additional_price_info ? `${additional_price_info} ${price}` : price : undefined,
      noPriceText: no_price_text,
      originalPrice: original_price,
      mode: mode,
      energyEfficiency: energy_efficiency ? energy_efficiency : undefined,
      hideEnergyEfficiency: hideEnergyEfficiency,
      hideDescription: hideDescription,
      hideRating: hideRating,
      hideBadge: hideBadge,
      badge: badge_details && /*#__PURE__*/React.createElement(StackedBadge, {
        badge_details: badge_details,
        conditions: conditions,
        package_description: package_description,
        language: language
      }),
      colorVariantsIndicator: product_tile_infos && product_tile_infos.has_color_variants ? /*#__PURE__*/React.createElement(ColorVariantsIndicator, {
        colorVariantsHint: product_tile_infos && product_tile_infos.color_variants_hint ? product_tile_infos.color_variants_hint : undefined
      }) : undefined,
      frozenIndicator: product_tile_infos && product_tile_infos.frozen_pictogram && product_tile_infos.frozen_pictogram.original ? /*#__PURE__*/React.createElement(FrozenPictogram, {
        pictogram: product_tile_infos.frozen_pictogram.original
      }) : undefined,
      ratings: ratings,
      language: language
    }))))));
  }
  return /*#__PURE__*/React.createElement(ArticleSkeleton, {
    mode: mode
  });
};